class BundleBuilder extends HTMLElement {

  constructor() {
    super();
    this.promises = [];
    this.bundleTitle = this.getAttribute('data-bundle-title');
    this.bundleProductHandle = this.getAttribute('data-bundle-product-handle');
    this.bundleProductId = this.getAttribute('data-bundle-product-id');
    this.bundleMin = parseInt(this.getAttribute('data-bundle-min'));
    this.bundleMax = parseInt(this.getAttribute('data-bundle-max'));
    this.bundleDiscount = parseInt(this.getAttribute('data-bundle-discount'));
    this.init();
  }

  init() {
    const bundleItems = this.querySelectorAll('.js-bundle-item-placeholder'); 

    bundleItems.forEach((el, index) => {
      this.buildProduct(el, index);
    });

    Promise.allSettled(this.promises)
    .then(() => {
      this.classList.remove('bundle-builder--loading');
      this.listeners();
      this.promises = [];
    });
  }

  buildProduct(el, index) {
    const url = el.getAttribute('data-bundle-item-url');
    const handle = el.getAttribute('data-bundle-item-handle');

    const getProduct = () => {
      const promise = new Promise(resolve => {
        async function getProductInfo(url) {
          
          let response = await fetch(url);
          let res = await response.text();
          let parser = new DOMParser();
          let data = parser.parseFromString(res, "text/html");
          return data;
        }

        getProductInfo(url).then((data) => {
          const product = data.querySelector('.js-bundle-item');

          if (product) {
            resolve({ product: product.innerHTML, index: index });
          } else {
            resolve(null);
          }
        })
      });
  
      this.promises.push(promise);
  
      return promise;
    }

    getProduct()
    .then((data) => {
      const productPlaceholders = document.querySelectorAll(`.js-bundle-item-placeholder-${handle}`);
    
      productPlaceholders.forEach((el) => {
        if (data && data.product) {
          const category = el.getAttribute('data-bundle-category');
  
          el.innerHTML = data.product;
  
          const card = el.querySelector('.js-bundle-card');
          const modalShow = el.querySelector('.js-bundle-modal-show');

          if (card) {
            card.setAttribute('data-bundle-category', category);
            card.setAttribute('data-bundle-index', index);
          }

          if (modalShow) {
            modalShow.setAttribute('data-modal-category', category);
            modalShow.setAttribute('data-modal-index', index);
          }
        } else {
          el.style.display = 'none';
        }
      });
    });
  }

  listeners() {
    const form = this.querySelector('.js-bundle-builder-form');
    const clearButton = this.querySelectorAll('.js-bundle-clear');
    const bundleSteps = this.querySelectorAll('.bundle-builder__details-item');

    if (form) {
      form.addEventListener('submit', (e) => {
        const submitButton = this.querySelector('.js-bundle-submit');
        const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-product-form');
        
        e.preventDefault();
        
        if (bundleItems.length < this.bundleMin || bundleItems.length > this.bundleMax) {
          let min = ''
          
          if (this.bundleMin !== this.bundleMax) {
            min = `${this.bundleMin}-`;
          }

          const minMaxError = bundleBuilderStrings.minMaxError.replace('[min]', min).replace('[max]', this.bundleMax);
          
          document.dispatchEvent(
            new CustomEvent('alert:show', { 
              detail: {
                data: {
                  message: `${minMaxError}`,
                  status: 'Error'
                }
              }
            })
          );
          
          return;
        }

        if (submitButton.getAttribute('disabled')) {
          return;
        }
  
        form.classList.add('is-loading');

        const timeStamp = Date.now();
        const formData = {
          items: []
        };
        
        bundleItems.forEach((el) => {
          const id = el.querySelector('input[name="id"]').value;

          formData.items.push({
            id: id,
            quantity: 1,
            properties: {
              '_Bundle Item': 'true',
              '_Bundle Title': this.bundleTitle,
              '_Bundle Product Handle': this.bundleProductHandle,
              '_Bundle Discount': this.getAttribute('data-total-discount'),
              '_Bundle Price': this.getAttribute('data-discounted-price'),
              '_Bundle Original Price': this.getAttribute('data-original-price')
            }
          })
        });

        formData.items.forEach((el) => {
          el.properties['_Bundle Identifier'] = `${this.bundleProductId}:${timeStamp}`;
        });

        document.dispatchEvent(
          new CustomEvent('cart:add', { 
            detail: {
              data: { formData: JSON.stringify(formData), multiple: true, sections: 'stmt-popout-cart' }
            }
          })
        )
      });

      document.addEventListener('bundle:addItem', (e) => {
        const productId = e.detail.data.formData.get('productId');
        const currentVariant = e.detail.data.currentVariant;
        const category = e.detail.data.category;
        const index = e.detail.data.index;

        document.dispatchEvent(
          new CustomEvent('bundle:variantChange', {
            detail: {
              data: {
                productId: productId,
                variant: currentVariant,
                category: category,
                index: index
              }
            }
          })
        )
      });
  
      document.addEventListener('bundle:updatePrice', () => {
        this.updatePrice();
      });

      document.addEventListener('bundle:updateItemCount', () => {
        this.updateItemCount();
      });
    }

    if (clearButton) {
      clearButton.forEach((el) => {
        el.addEventListener('click', () => {
          this.clear();
        });
      });
    }

    if (bundleSteps) {
      if (window.matchMedia("only screen and (max-width: 780px)").matches) {
        document.addEventListener('bundle:addItem', () => {
          let activeStep = document.querySelector('.bundle-builder__details-item.is-active');
          let nextStep = activeStep.nextElementSibling;
  
          if (activeStep && nextStep) {
            activeStep.classList.remove('is-active')
            nextStep.classList.add('is-active');
            let nextStepPosition = nextStep.getBoundingClientRect();
            window.scrollTo(nextStepPosition.left, nextStepPosition.top + window.scrollY - 150);
          } else if (nextStep == null) {
            activeStep.classList.remove('is-active');
          }
        })
      }
    }
  }

  clear() {
    const bundleCards = this.querySelectorAll('.js-bundle-card');

    bundleCards.forEach((el) => {
      el.classList.remove('bundle-item--checked');
      el.classList.remove('js-bundle-card-checked');
      el.classList.remove('bundle-item--disabled');
    });

    this.updatePrice();
    this.updateItemCount();
  }

  updatePrice() {
    const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-product-form');
    const bundlePrice = this.querySelectorAll('.js-bundle-price');
    const discount = (100 - this.bundleDiscount) / 100;

    let totalPrice = 0;
    let totalCompareAtPrice = 0;

    bundleItems.forEach((el) => {
      const price = parseInt(el.getAttribute('data-variant-price'));
      const compareAtPrice = parseInt(el.getAttribute('data-variant-compare-at-price'));

      if (isNaN(price)) return;

      if (!isNaN(compareAtPrice)) {        
        totalPrice += price;
        totalCompareAtPrice += compareAtPrice;
      } else {
        totalPrice += Math.round(price * discount);
        totalCompareAtPrice += price;
      }
    });

    this.setAttribute('data-discounted-price', totalPrice);
    this.setAttribute('data-original-price', totalCompareAtPrice);
    this.setAttribute('data-total-discount', totalCompareAtPrice - totalPrice);

    bundlePrice.forEach((el) => {
      if (totalPrice === 0 || totalCompareAtPrice === 0) {
        el.innerHTML = Shopify.formatMoney(totalPrice, window.money.format)
      } else {
        el.innerHTML = `
          <span class="bundle-builder__price-sale">${Shopify.formatMoney(totalPrice, window.money.format)}</span>
          <s class="bundle-builder__price-compare-at-price">${Shopify.formatMoney(totalCompareAtPrice, window.money.format)}</s>
        `
      }
    })
  }

  updateItemCount() {
    const categories = this.querySelectorAll('.js-bundle-builder-category');
    const bundleItems = this.querySelectorAll('.js-bundle-card-checked .js-product-form');
    const bundleItemCount = bundleItems.length;
    const submitButton = this.querySelectorAll('.js-bundle-submit');
    const clearButton = this.querySelectorAll('.js-bundle-clear');
    const totalItemsSidebar = this.querySelector('.js-bundle-total-items-sidebar');
    const progressBarSidebar = this.querySelector('.js-bundle-progress-bar-sidebar');
    const sidebarProgress = 1 - (bundleItemCount / this.bundleMax);
    const totalItems = this.querySelector('.js-bundle-total-items');
    const progressBar = this.querySelector('.js-bundle-progress-bar');
    const progress = (bundleItemCount / this.bundleMax) * 100;
    let itemLimit = this.bundleMax;

    categories.forEach((el) => {
      const bundleItems = el.querySelectorAll('.js-bundle-card-checked .js-product-form');

      if (bundleItems.length) {
        el.classList.add('bundle-builder__details-item--has-selected');
      } else {
        el.classList.remove('bundle-builder__details-item--has-selected');
      }
    });

    totalItemsSidebar.innerText = bundleItemCount;
    progressBarSidebar.style.strokeDashoffset = 198 * sidebarProgress;

    if (this.bundleMin !== this.bundleMax) {
      itemLimit = `${this.bundleMin}-${this.bundleMax}`;
    }

    totalItems.innerText = bundleBuilderStrings.totalSelected.replace('[selected]', bundleItemCount).replace('[limit]', itemLimit);
    progressBar.style.width = `${progress}%`;

    if (bundleItemCount >= this.bundleMin) {
      submitButton.forEach((el) => {
        el.removeAttribute('disabled');
      })
    } else {
      submitButton.forEach((el) => {
        el.setAttribute('disabled', 'disabled');
      })
    }

    if (bundleItemCount >= this.bundleMax) {
      categories.forEach((el) => {
        if (!el.classList.contains('bundle-builder__details-item--has-selected')) {
          el.classList.add('bundle-builder__details-item--max-reached');
        }
      })
    } else {
      categories.forEach((el) => {
        el.classList.remove('bundle-builder__details-item--max-reached');
      })
    }

    if (bundleItemCount === 0) {
      clearButton.forEach((el) => {
        el.setAttribute('disabled', 'disabled');
      })
    } else {
      clearButton.forEach((el) => {
        el.removeAttribute('disabled');
      })
    }
  }
}

customElements.define('bundle-builder', BundleBuilder);

class BundleBuilderCard extends SiteProductForm {

  constructor() {
    super();
  }

  listeners() {
    const self = this;
    const checkboxes = this.querySelectorAll('.js-bundle-card-checkbox');

    document.addEventListener('bundle:variantChange', (e) => {
      const variant = e.detail.data.variant;
      const category = document.querySelector(`#${e.detail.data.category}`);  
      const categoryCards = category.querySelectorAll('.js-bundle-card');
      const index = e.detail.data.index;

      if (category.contains(this)) {
        if (this.getAttribute('data-bundle-index') === index && variant) {
          this.updateSelectedVariant(variant);
          this.updateItemModalLink(variant);
  
          this.classList.add('bundle-item--checked', 'js-bundle-card-checked');
                    
          document.dispatchEvent(
            new CustomEvent('modal:hide')
          )
            
          document.dispatchEvent(
            new CustomEvent('bundle:updatePrice')
          )

          document.dispatchEvent(
            new CustomEvent('bundle:updateItemCount', )
          )
        }
      }

      categoryCards.forEach((el) => {
        if (!el.classList.contains('js-bundle-card-checked')) {
          el.classList.add('bundle-item--disabled');
        } else {
          el.classList.remove('bundle-item--disabled');
        }
      });
    });
    
    checkboxes.forEach((el) => {
      el.addEventListener('click', () => {
        const category = document.querySelector(`#${self.getAttribute('data-bundle-category')}`);
        const categoryCards = category.querySelectorAll('.js-bundle-card');

        self.classList.remove('bundle-item--checked');
        self.classList.remove('js-bundle-card-checked');

        categoryCards.forEach((el) => {
          el.classList.remove('bundle-item--disabled');
        });

        document.dispatchEvent(
          new CustomEvent('bundle:updatePrice')
        )

        document.dispatchEvent(
          new CustomEvent('bundle:updateItemCount')
        )
      });
    })
  }
}

customElements.define('bundle-builder-card', BundleBuilderCard);
